/**
 * TEMPORARY Provider - need to be removed after we move to react first
 *
 * This singleton provider pattern is a temporary solution until we move to react first.
 * Currently needed because HoneybookAIProvider at the root level and we have multiple Angular entry points.
 * After we move to react first, we will only use the HoneybookAIProvider instance in AppContextProvider.
 */

import React, { createContext } from 'react';
import { HoneybookAI, IHoneybookAI } from '../ai-core';
import {
    useHttpClient,
    useLogger,
    useStreamingProviderFactory,
    useStorage,
    useAppLifecycle
} from '~/packages/core-react';
import {
    IHttpClient,
    ILogger,
    IStreamingProviderFactory,
    IStorage,
    IAppLifecycleProvider
} from '~/packages/core';

interface HoneybookAIProviderStoreParams {
    httpClient: IHttpClient;
    logger: ILogger;
    streamingProviderFactory: IStreamingProviderFactory;
    storage: IStorage;
    appLifecycleProvider: IAppLifecycleProvider;
}

let honeybookAI: IHoneybookAI = null;
export const cleanupHoneybookAI = () => {
    if (honeybookAI) {
        honeybookAI = null;
    }
};

/**
 * Store for managing the HoneybookAI instance.
 * Initializes the AI client with provided dependencies.

 */
class HoneybookAIProviderStore {
    get ai(): IHoneybookAI {
        return honeybookAI;
    }
    initialize({
        httpClient,
        logger,
        streamingProviderFactory,
        storage,
        appLifecycleProvider
    }: HoneybookAIProviderStoreParams) {
        if (
            !honeybookAI &&
            httpClient &&
            logger &&
            streamingProviderFactory &&
            storage &&
            appLifecycleProvider
        ) {
            honeybookAI = new HoneybookAI({
                httpClient,
                streamingProviderFactory,
                logger,
                storage,
                appLifecycleProvider
            });
        }
    }
}

const honeybookAIProviderStore = new HoneybookAIProviderStore();
export const HoneybookAISingletonContext =
    createContext<HoneybookAIProviderStore>(honeybookAIProviderStore);

// Provider props interface
interface HoneybookAIProviderProps {
    children: React.ReactNode;
}

/**
 * Provider component for HoneybookAI.
 * Initializes the AI client and makes it available to all child components.
 */
export const HoneybookAISingletonProvider = ({
    children
}: HoneybookAIProviderProps) => {
    const httpClient = useHttpClient();
    const logger = useLogger();
    const streamingProviderFactory = useStreamingProviderFactory();
    const storage = useStorage();
    const appLifecycleProvider = useAppLifecycle();

    honeybookAIProviderStore.initialize({
        httpClient,
        logger,
        streamingProviderFactory,
        storage,
        appLifecycleProvider
    });

    return (
        <HoneybookAISingletonContext.Provider value={honeybookAIProviderStore}>
            {children}
        </HoneybookAISingletonContext.Provider>
    );
};
